import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './ThemeContext.jsx'
import withLoadingScreen from './withLoadingScreen.jsx'
import HomePage from '../HomePage.jsx'
import ProjectPage from '../ProjectPage.jsx'
import BlogPage from '../BlogPage.jsx'
import AboutMePage from '../AboutMePage.jsx'
import ContactPage from '../ContactPage.jsx'
import ScheduleCallPage from '../ScheduleCallPage.jsx'

import AgenticChatPage from '../AgenticChatPage.jsx'


// Wrap all pages with loading screen
const HomePageWithLoading = withLoadingScreen(HomePage, { minLoadingTime: 1500, maxLoadingTime: 3000 })
const ProjectPageWithLoading = withLoadingScreen(ProjectPage, { minLoadingTime: 1500, maxLoadingTime: 3000 })
const BlogPageWithLoading = withLoadingScreen(BlogPage, { minLoadingTime: 1500, maxLoadingTime: 3000 })
const AboutMePageWithLoading = withLoadingScreen(AboutMePage, { minLoadingTime: 1500, maxLoadingTime: 3000 })
const ContactPageWithLoading = withLoadingScreen(ContactPage, { minLoadingTime: 1500, maxLoadingTime: 3000 })
const ScheduleCallPageWithLoading = withLoadingScreen(ScheduleCallPage, { minLoadingTime: 1500, maxLoadingTime: 3000 })

const AgenticChatPageWithLoading = withLoadingScreen(AgenticChatPage, { minLoadingTime: 1500, maxLoadingTime: 3000 })


function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePageWithLoading />} />
          <Route path="/projects" element={<ProjectPageWithLoading />} />
          <Route path="/blog" element={<BlogPageWithLoading />} />
          <Route path="/about-me" element={<AboutMePageWithLoading />} />
          <Route path="/contact" element={<ContactPageWithLoading />} />
          <Route path="/schedule-call" element={<ScheduleCallPageWithLoading />} />

          <Route path="/agentic-chat" element={<AgenticChatPageWithLoading />} />

        </Routes>
      </Router>
    </ThemeProvider>
  )
}

export default App